export const GET_CARD_EULA_ACCEPTANCE_USER_GRID =
  '/api/payment/get-card-eula-acceptance-user-grid';

export const GET_CARD_EULA_ACCEPTANCE_USER_GRID_DISTINCT =
  '/api/payment/get-card-eula-acceptance-user-grid/distinct';

export const CREATE_CARD_EULA = '/api/payment/create-card-eula';

export const CLONE_CARD_EULA = '/api/payment/clone-card-eula';

export const DELETE_CARD_EULA = '/api/payment/delete-card-eula';

export const GET_CARD_EULA = '/api/payment/get-card-eula';

export const GET_CARD_EULA_SHORT_DETAIL =
  '/api/payment/get-card-eula-short-detail';

export const GET_CARD_EULA_DETAIL_GRID =
  '/api/payment/get-card-eula-detail-grid';

export const GET_CARD_EULA_DETAIL_GRID_DISTINCT =
  '/api/payment/get-card-eula-detail-grid/distinct';

export const GET_PRODUCTS_FOR_CAPTURE = '/api/payment/get-products-for-capture';

export const MAKING_PRODUCT_ACTIVE = '/api/payment/make-product-active';

export const VALIDATE_ACTIVE_PRODUCT = '/api/payment/validate-active-product';

export const SEND_PRODUCT_TO_CAPTURE = '/api/payment/send-product-to-capture';

export const CHARGE_SAVED_MEMBER_CARD = '/api/payment/charge-member-saved-card';
